import { axiosCompanyPortalInstance, axiosInstance } from "./";

const EVENT_REQUESTS_PATH = "/event_requests";
const BULK_STATUS_VALIDATE = (status) =>
  (status >= 200 && status < 300) || status === 207;

const bulkPost = (path, data) =>
  axiosInstance.post(`${EVENT_REQUESTS_PATH}/${path}`, data, {
    validateStatus: BULK_STATUS_VALIDATE,
  });

const getRequestsList = async (params) =>
  await axiosInstance.get(EVENT_REQUESTS_PATH, { params });

const getCompanyPortalRequestsList = async (params) =>
  await axiosCompanyPortalInstance.get(EVENT_REQUESTS_PATH, { params });

const bulkApproveAdminEventRequests = (data) =>
  bulkPost("bulk_approve", data);

const bulkRejectEventRequests = (data) => bulkPost("bulk_reject", data);

const bulkAllocateAdminEventRequests = (data) =>
  bulkPost("bulk_allocate", data);

const bulkUnassignAdminEventRequests = (data) =>
  bulkPost("bulk_unassign", data);

const bulkRemoveAdminEventRequests = (data) => bulkPost("bulk_remove", data);

const bulkChangeRoleAdminEventRequests = (data) =>
  bulkPost("bulk_change_role", data);

const updateSupervisorEventRequest = async ({ data, id }) =>
  await axiosInstance.patch(`/zones/${id}`, data);

const getEventRequestList = async ({ id, params }) =>
  await axiosInstance.get(`/events/${id}/event_requests`, { params });

export {
  getRequestsList,
  getCompanyPortalRequestsList,
  updateSupervisorEventRequest,
  getEventRequestList,
  bulkApproveAdminEventRequests,
  bulkRejectEventRequests,
  bulkAllocateAdminEventRequests,
  bulkUnassignAdminEventRequests,
  bulkRemoveAdminEventRequests,
  bulkChangeRoleAdminEventRequests,
};
